import { render, staticRenderFns } from "./MStoreDashboardButton.vue?vue&type=template&id=1a76f0aa&"
import script from "./MStoreDashboardButton.vue?vue&type=script&lang=ts&"
export * from "./MStoreDashboardButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports